// components/home/QuickActions.jsx
import React from 'react';
import { motion } from 'framer-motion';
import { FaCalendarAlt, FaClock, FaFlask, FaAmbulance, FaPills, FaPhoneAlt } from 'react-icons/fa';

const QuickActions = () => {
    const actions = [
        {
            icon: <FaCalendarAlt className="text-3xl text-blue-600" />,
            title: "Appointment",
            description: "Book your consultation",
            link: "/appointments"
        },
        {
            icon: <FaClock className="text-3xl text-green-600" />,
            title: "OPD Schedule",
            description: "View timings",
            link: "/opd-schedule"
        },
        {
            icon: <FaFlask className="text-3xl text-purple-600" />,
            title: "Lab Services",
            description: "Get tested",
            link: "/lab-services"
        },
        {
            icon: <FaAmbulance className="text-3xl text-red-600" />,
            title: "Emergency",
            description: "24/7 emergency care",
            link: "/emergency"
        },
        {
            icon: <FaPills className="text-3xl text-yellow-600" />,
            title: "Pharmacy",
            description: "Medicines & supplies",
            link: "/pharmacy"
        },
        {
            icon: <FaPhoneAlt className="text-3xl text-teal-600" />,
            title: "Contact",
            description: "Get in touch",
            link: "/contact"
        }
    ];

    return (
        <section className="py-16 bg-white">
            <div className="max-w-screen-xl mx-auto px-6">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                    viewport={{ once: true }}
                    className="text-center mb-12"
                >
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">Quick Access</h2>
                    <p className="text-gray-600 max-w-2xl mx-auto">Get instant access to our essential services</p>
                </motion.div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-6">
                    {actions.map((action, index) => (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: index * 0.1 }}
                            viewport={{ once: true }}
                            whileHover={{ y: -5 }}
                            className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition duration-300 border border-gray-100 cursor-pointer"
                        >
                            <div className="flex flex-col items-center text-center">
                                <div className="mb-4 p-3 bg-gray-50 rounded-full">
                                    {action.icon}
                                </div>
                                <h3 className="text-lg font-semibold text-gray-800 mb-2">{action.title}</h3>
                                <p className="text-gray-600 text-sm mb-4">{action.description}</p>
                                <button className="text-blue-600 font-medium text-sm hover:text-blue-700">
                                    Learn More →
                                </button>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default QuickActions;